<template>
  <div id="footer">
    <iframe
      :src="iframeUrl"
      :style="{
        width: iframeWidth,
        'max-width': '95%',
        height: iframeHeight,
        border: 'none',
        'background-color': iframeBackground,
      }"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: ["iframeColor", "iframeBackground"],

  data() {
    return {
      iframeWidth: "0",
      iframeHeight: "0",
      lang: BX24.getLang(),
    };
  },
  computed: {
    iframeUrl() {
      const background = this.prepareUrlParam(this.iframeBackground);
      const color = this.prepareUrlParam(this.iframeColor);
      return `https://local.app.support.pl/app-resource-library/footer/?background=${background}&color=${color}&lang=${this.lang}`;
    },
  },
  async mounted() {
    // ----------------------------
    const res = await this.fetchData(".iframeSize");
    if (res && res.data) {
      if (res.data.iframeWidth) {
        this.iframeWidth = res.data.iframeWidth;
      }

      if (res.data.iframeHeight) {
        setTimeout(() => {
          this.iframeHeight = res.data.iframeHeight;
        }, 1000);
      }
    }

    setTimeout(() => BX24.fitWindow(), 1000);
  },
  methods: {
    async fetchData(name) {
      const url =
        "https://local.app.support.pl/app-resource-library/footer/ajax/index.php";
      const data = {
        name: name, // Название файла без расширения
      };
      let result = {};
      try {
        const response = await fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          throw new Error(`Ошибка: ${response.status}`);
        }

        result = await response.json();
      } catch (error) {
        console.error("Ошибка при запросе:", error);
      }

      return result;
    },

    prepareUrlParam(param) {
      try {
        // Кодируем параметр и заменяем символы, которые могут вызвать проблемы
        return encodeURIComponent(param);
      } catch (error) {
        console.error("Error preparing URL parameter:", error);
        return null; // Возвращаем null в случае ошибки
      }
    },
  },
};
</script>

<style scoped></style>
